import AosText from './aos-text';
export default AosText